import { Switch, Route } from 'react-router-dom';
import NuvemAppPage from 'domains/PartnersApps/pages/NuvemAppPage';
import GeneralStatsPlanThreePage from '../Pages/GeneralStatsPlanThreePage';
import StatisticsAcquisitionPage from '../Pages/StatisticsAcquisitionPage';
import StatisticsPaymentsPage from '../Pages/StatisticsPaymentsPage';
import StatisticsProductsPage from '../Pages/StatisticsProductsPage';
import StatisticsShippingPage from '../Pages/StatisticsShippingPage';
import { STATS_ROUTES } from '../statisticsRoutes';

function StatsRoutes() {
  return (
    <Switch>
      <Route path={STATS_ROUTES.stats} exact>
        <GeneralStatsPlanThreePage />
      </Route>
      <Route path={STATS_ROUTES.products}>
        <StatisticsProductsPage />
      </Route>
      <Route path={STATS_ROUTES.payments}>
        <StatisticsPaymentsPage />
      </Route>
      <Route path={STATS_ROUTES.acquisition}>
        <StatisticsAcquisitionPage />
      </Route>
      <Route path={STATS_ROUTES.shipping}>
        <StatisticsShippingPage />
      </Route>
      <Route path={STATS_ROUTES.nubeinsightsLiveview}>
        <NuvemAppPage code="nubeinsights-liveview" />
      </Route>
      <Route path={STATS_ROUTES.nubeinsightsCoupons}>
        <NuvemAppPage code="nubeinsights-coupons" />
      </Route>
      <Route path={STATS_ROUTES.nubeinsightsGeneral}>
        <NuvemAppPage code="nubeinsights-general" />
      </Route>
      <Route path={STATS_ROUTES.nubeinsightsVisits}>
        <NuvemAppPage code="nubeinsights-visits" />
      </Route>
      <Route path={STATS_ROUTES.nubeinsightsProducts}>
        <NuvemAppPage code="nubeinsights-products" />
      </Route>
      <Route path={STATS_ROUTES.nubeinsightsSales}>
        <NuvemAppPage code="nubeinsights-sales" />
      </Route>
      <Route path={STATS_ROUTES.nubeinsightsSearchInsights}>
        <NuvemAppPage code="nubeinsights-search-insights" />
      </Route>
    </Switch>
  );
}

export default StatsRoutes;
